var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('e-input-wrapper',{key:[item.model, '-', index].join(''),attrs:{"ctx":_vm.morphedCtx(item),"item":item,"dynamic":_vm._.get(item.attrs, 'dynamic', false),"value":_vm.fieldVal(item)},on:{"input":function($event){_vm.$emit(['update:', item.model].join(''), $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }